import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum FinancialAdviser {
  ARISTOTLE = "ARISTOTLE",
  USER_PREFERRED = "USER_PREFERRED",
  NO_AGENT = "NO_AGENT",
}

export interface IFARresponse {
  status: boolean | null;
  responseErrorDetail: string | null;
  totalPages: string | number;
  totalItems: string | number;
  logoutUser: boolean | null;
  validPromoCode: string;
  data: {
    clientNum: string;
    clientType: string;
    surname: string;
    givname: string;
    salutation: string;
    fullName: string;
    nric: string;
    dob: string;
    gender: string;
    maritalStatus: string;
    nationality: string;
    race: string;
    homeNum: string;
    mobileNum: string;
    officeNum: string;
    faxNum: string | null;
    emailId: string;
    residential_Addr_1: string;
    residential_Addr_2: string;
    residential_Addr_3: string;
    residential_Addr_4: string;
    residential_Addr_5: string;
    residentialAddrCountry: string;
    residentialAddrPostalCode: string;
    agentTerminatedFlag: string;
    agentSourceOfBusiness: string;
  };
}

interface Payment {
  paymentMethod: "" | "cc" | "fast";
  interbankFastForm: null;
  paymentRef: null | string;
  isPayingSelf: "yes" | "no" | "";
  policyNumber: null | string;
  creditCard: any;
  status?: string;
}

interface Step6State {
  FARData: {
    isNeed?: string;
    name?: string;
    code?: string;
  };
  financialAdviserLink: boolean;
  arcCode: string;
  promoCode: string;
  showArcPage: boolean;
  declarationAcceptance: boolean;
  financialAdviser: {
    adviserData: IFARresponse | { data: null };
    autoAssignAgent: string;
  };
  payment: Payment;
  referenceNumber?: null | string;
}

const initialState: Step6State = {
  FARData: {
    isNeed: "",
    name: "",
    code: "",
  },
  financialAdviserLink: false,
  arcCode:"",
  promoCode: "",
  declarationAcceptance: false,
  showArcPage: false,
  financialAdviser: {
    adviserData: {
      validPromoCode: '',
      logoutUser: null,
      responseErrorDetail: "",
      status: null,
      totalItems: "",
      totalPages: "",
      data: {
        clientNum: "",
        clientType: "",
        surname: "",
        givname: "",
        salutation: "",
        fullName: "",
        nric: "",
        dob: "",
        gender: "",
        maritalStatus: "",
        nationality: "",
        race: "",
        homeNum: "",
        mobileNum: "",
        officeNum: "",
        faxNum: null,
        emailId: "",
        residential_Addr_1: "",
        residential_Addr_2: "",
        residential_Addr_3: "",
        residential_Addr_4: "",
        residential_Addr_5: "",
        residentialAddrCountry: "",
        residentialAddrPostalCode: "",
        agentTerminatedFlag: "",
        agentSourceOfBusiness: "",
      },
    },
    autoAssignAgent: "",
  },
  payment: {
    paymentMethod: "",
    isPayingSelf: "",
    interbankFastForm: null,
    paymentRef: null,
    policyNumber: null,
    creditCard: null,
  },
  referenceNumber: null,
};

const step6Slice = createSlice({
  name: "CancerCover-Step6",
  initialState,
  reducers: {
    updateFARData: (
      state,
      action: PayloadAction<
        Partial<{
          isNeed: string;
          name: string;
          code: string;
        }>
      >
    ) => {
      state.FARData = {
        ...state.FARData,
        ...action.payload,
      };
    },
    updateFinancialAdviser: (
      state,
      action: PayloadAction<IFARresponse | { data: null }>
    ) => {
      state.financialAdviser.adviserData = action.payload;
    },
    updateFinancialAdviserLink: (state, action: PayloadAction<boolean>) => {
      state.financialAdviserLink = action.payload;
    },
    updateAssignedAgentOption: (state, action: PayloadAction<string>) => {
      state.financialAdviser.autoAssignAgent = action.payload;
    },
    updateArcCode: (state, action: PayloadAction<string>)=>{
      state.arcCode = action.payload
    },
    updatePromoCode: (state, action: PayloadAction<string>) => {
      state.promoCode = action.payload;
    },
    updateDeclarationAcceptance: (state, action: PayloadAction<boolean>) => {
      state.declarationAcceptance = action.payload;
    },
    updatePaymentData: (state, action: PayloadAction<Partial<Payment>>) => {
      state.payment = { ...state.payment, ...action.payload };
    },
    updateShowArcPage: (state, action: PayloadAction<boolean>) => {
      state.showArcPage = action.payload;
    },
    updateReferenceNumber: (state, action: PayloadAction<string>) => {
      state.referenceNumber = action.payload;
    },
    updateToIntialState6: (state, action: PayloadAction<any>) => ({
      ...initialState,
    }),
  },
  extraReducers: {},
});

export const {
  updateFARData,
  updateFinancialAdviser,
  updateFinancialAdviserLink,
  updateAssignedAgentOption,
  updateDeclarationAcceptance,
  updatePaymentData,
  updateShowArcPage,
  updateReferenceNumber,
  updateToIntialState6,
  updateArcCode,
  updatePromoCode
} = step6Slice.actions;

export default step6Slice.reducer;
